import { Component, Prop, h, Host } from '@stencil/core';

const COMPONENT_NAME = 'call-to-action-type-11';

/**
 * Centered call-to-action section with label, heading, and a sign-up form.
 * Single-column centered layout. Supports background media via slot.
 * Supports pure slot pass-through for inline editing in the visual editor.
 *
 * @product signnow
 * @version 2.0.0
 * @category SignNow
 * @contentConfig Call-to-action component for encouraging user engagement and sign-ups
 * @example
 *   <sn-call-to-action-type-3>
 *     <me-text slot="label" tag="span" class="me-text--label">be ready to get more</me-text>
 *     <me-heading slot="heading" variant="2" tag="h4">Join over 28 million airSlate SignNow users</me-heading>
 *     <form-free-trial-type-1 slot="action-primary" button-variant="primary" mobile-layout="stacked" note="No credit card required" submit-text="Start your free trial"></form-free-trial-type-1>
 *   </sn-call-to-action-type-3>
 * @slot label - <me-text tag="span" class="me-text--label"> - Small label displayed above the heading
 * @slot heading - {required}, <me-heading variant="2" tag=["h1", "h2", "h3", "h4", "h5", "h6", "div"]> - Main CTA heading
 * @slot action-primary - {required}, <form-free-trial-type-1>, <me-button variant="primary"> - Primary action or sign-up form
 */
@Component({
  tag: 'sn-call-to-action-type-3',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNCallToActionType3 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <me-section
          class={`${COMPONENT_NAME} sn-call-to-action-type-3`}
          yGap="2xl"
          yGapLg="5xl"
          role="region"
          aria-label="Call to Action"
        >
          <me-row
            yGapLg="none"
            yGap="none"
            xGapLg="none"
            xGap="none"
            justify="center"
            justifyLg="center"
            class={`${COMPONENT_NAME}__content`}
          >
            <me-column spanMd="8" span="12" class={`${COMPONENT_NAME}__intro`}>
              <div class={`${COMPONENT_NAME}__intro-inner`}>
                <slot name="label"></slot>
                <slot name="heading"></slot>
                <me-row xGap="md" xGapLg="md" yGap="md" yGapLg="md" justify="center" justifyLg="center">
                  <me-column span="auto">
                    <slot name="action-primary"></slot>
                  </me-column>
              </me-row>
              </div>
            </me-column>
          </me-row>
        </me-section>
      </Host>
    );
  }
}
